/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Alarms_Form_Objecttype_Label1Inputs */



/**
* | output |
* | --- |
* | "Variable type" |
*
* @param {Alarms_Form_Objecttype_Label1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const alarms_form_objecttype_label1 = /** @type {((inputs?: Alarms_Form_Objecttype_Label1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Alarms_Form_Objecttype_Label1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Variable type")
	return /** @type {LocalizedString} */ ("Type de variable")
});
export { alarms_form_objecttype_label1 as "alarms_form_objectType_label" }